/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SurfaceCtaAction = {
    FOLLOW_HUB: 'FOLLOW_HUB',
    EXTERNAL_LINK: 'EXTERNAL_LINK',
    SCROLL_TO_SECTION: 'SCROLL_TO_SECTION',
    LOGIN: 'LOGIN'
} as const;
export type SurfaceCtaAction = typeof SurfaceCtaAction[keyof typeof SurfaceCtaAction];


export function instanceOfSurfaceCtaAction(value: any): boolean {
    for (const key in SurfaceCtaAction) {
        if (Object.prototype.hasOwnProperty.call(SurfaceCtaAction, key)) {
            if (SurfaceCtaAction[key as keyof typeof SurfaceCtaAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceCtaActionFromJSON(json: any): SurfaceCtaAction {
    return SurfaceCtaActionFromJSONTyped(json, false);
}

export function SurfaceCtaActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCtaAction {
    return json as SurfaceCtaAction;
}

export function SurfaceCtaActionToJSON(value?: SurfaceCtaAction | null): any {
    return value as any;
}

export function SurfaceCtaActionToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceCtaAction {
    return value as SurfaceCtaAction;
}

